













import Vue from "vue";
import { mapState, mapActions } from "vuex";
import {
  ProductTabFilterOptions,
  PageConfig,
  DateFilterItems
} from "../../types";
import { encodeQueryParams } from "@canvas/api/lib/utils";
import ProductTable from "../ProductTable.vue";
import SKUNameRenderer from "../TableRenderers/SKUNameRenderer.vue";
import AvailabilityRenderer from "../TableRenderers/AvailabilityRenderer.vue";
import TableActionEditRenderer from "../TableRenderers/TableActionEditRenderer.vue";
import DesignerDetailsRenderer from "./DesignerDetailsRenderer.vue";
import NameRenderer from "../TableRenderers/NameRenderer.vue";
import SampleNameRenderer from "./SampleNameRenderer.vue";
import { formatDateForQuery } from "@/utils";

const dateOptions = {
  year: "numeric",
  month: "short",
  day: "numeric"
};
export default Vue.extend({
  name: "manage-products",
  components: {
    ProductTable
  },
  data(): { [key: string]: any } {
    return {
      searchData: {
        searchText: "",
        option: ""
      },
      dateFilter: Object.assign(
        DateFilterItems[0],
        {
          displayText: DateFilterItems[0].displayName
        },
        { start_date: null, end_date: null }
      ),
      historyTableColumns: [
        {
          name: "sample_id",
          display_name: "SAMPLE ID",
          fixed: false,
          width: 20,
          headrenderer: null,
          cellrenderer: SampleNameRenderer
        },
        {
          name: "issued_to",
          display_name: "ISSUED TO",
          fixed: false,
          width: 20,
          headrenderer: null,
          cellrenderer: DesignerDetailsRenderer
        },
        {
          name: "issue_date",
          display_name: "ISSUED ON",
          fixed: false,
          width: 15,
          headrenderer: null,
          cellrenderer: NameRenderer
        },
        {
          name: "return_date",
          display_name: "RETURNED ON",
          fixed: false,
          width: 15,
          headrenderer: null,
          cellrenderer: NameRenderer
        },
        {
          name: "issue_condition",
          display_name: "ISSUE CONDITION",
          fixed: false,
          width: 15,
          headrenderer: null,
          cellrenderer: NameRenderer
        },
        {
          name: "return_condition",
          display_name: "RETURN CONDITION",
          fixed: false,
          width: 15,
          headrenderer: null,
          cellrenderer: NameRenderer
        }
      ]
    };
  },
  provide(): any {
    return {
      actionHandler: this.handleTableAction
    };
  },
  computed: {
    ...mapState("uiModule", {
      modalElement: "modalElement"
    }),
    ...mapState("appModule", {
      selectedEc: "selectedEc",
      historyTableData: "lendingHistoryDetails"
    })
  },
  methods: {
    ...mapActions("appModule", ["searchLendingHistory"]),
    updateRoute() {
      let apiQuery = {
        [this.searchData.option.name]: this.searchData.searchText,
        limit: this.historyTableData.pageConfig.limit,
        offset: this.historyTableData.pageConfig.offset,
        ec_id__in: this.selectedEc.name
      };
      if (this.historyTableData.pageConfig.dateFilter) {
        apiQuery = Object.assign(
          apiQuery,
          this.historyTableData.pageConfig.dateFilterQuery
        );
      }
      this.historyTableData.pageConfig.query = encodeQueryParams(apiQuery);
      const routeLink =
        "/" +
        this.selectedEc.name +
        "/trxnhistory/" +
        JSON.stringify({
          search: this.searchData,
          pageConfig: this.historyTableData.pageConfig
        });
      this.searchHistory();
      this.$router.push({
        path: routeLink
      });
    },
    searchHistory() {
      return this.searchLendingHistory(this.historyTableData.pageConfig);
    },
    handleTableAction(actionType: string, data: any) {
      switch (actionType) {
        case "pageIncrease":
        case "pageDecrease":
        case "goToPage":
          this.historyTableData.pageConfig.offset =
            this.historyTableData.pageConfig.limit * (data - 1);
          this.historyTableData.pageConfig.page = data;
          this.updateRoute();
          break;
        case "setPageLength":
          this.historyTableData.pageConfig.limit = data;
          this.historyTableData.pageConfig.page = 1;
          this.historyTableData.pageConfig.offset = 0;
          this.updateRoute();
          break;
        case "setDateFilter":
          //sets the date filter to the selected datefilter type
          this.dateFilter = data;
          this.dateFilter.displayText = this.dateFilter.displayName;
          if (data.name === DateFilterItems[0].name) {
            this.dateFilter = Object.assign(DateFilterItems[0], {
              displayText: DateFilterItems[0].displayName
            });
            this.historyTableData.pageConfig = JSON.parse(
              JSON.stringify(PageConfig)
            );
            this.historyTableData.pageConfig.dateFilterQuery = "";
            this.updateRoute();
          }
          break;
        case "applyDateFilter":
          //calculate the appropriate date filter when Apply Button is clicked
          this.dateFilter = data;
          this.dateFilter.displayText = this.dateFilter.displayName;
          //when show_all is not selected then calculate the date filters
          if (
            this.dateFilter.start_date &&
            this.dateFilter.end_date &&
            data.name !== DateFilterItems[0].name
          ) {
            this.dateFilter.displayText =
              this.dateFilter.displayText +
              " : " +
              new Date(this.dateFilter.start_date).toLocaleDateString(
                "en",
                dateOptions as any
              ) +
              " - " +
              new Date(this.dateFilter.end_date).toLocaleDateString(
                "en",
                dateOptions as any
              );
            this.applyDateFilter();
          }
          break;
      }
    },
    applyDateFilter() {
      //convert the filters in the appropriate format
      this.historyTableData.pageConfig.dateFilter = this.dateFilter;
      switch (this.dateFilter.name) {
        case "return_date":
          this.historyTableData.pageConfig.dateFilterQuery = {
            return_date__range: formatDateForQuery(
              new Date(this.dateFilter.start_date),
              new Date(this.dateFilter.end_date)
            )
          };
          this.updateRoute();
          break;
        case "issue_date":
          this.historyTableData.pageConfig.dateFilterQuery = {
            issue_date__range: formatDateForQuery(
              new Date(this.dateFilter.start_date),
              new Date(this.dateFilter.end_date)
            )
          };
          this.updateRoute();
          break;
        case "expected_return_date":
          this.historyTableData.pageConfig.dateFilterQuery = {
            expected_return_date__range: formatDateForQuery(
              new Date(this.dateFilter.start_date),
              new Date(this.dateFilter.end_date)
            ),
            return_date__isnull: "true"
          };
          this.updateRoute();
          break;
      }
    },
    initManageHistory() {
      const parsedJSONData = JSON.parse(
        this.$router.currentRoute.params.searchQuery
      );
      this.searchData = parsedJSONData.search ? parsedJSONData.search : {};
      this.historyTableData.pageConfig = parsedJSONData.pageConfig
        ? parsedJSONData.pageConfig
        : PageConfig;
      if (parsedJSONData.pageConfig && parsedJSONData.pageConfig.dateFilter) {
        this.dateFilter = parsedJSONData.pageConfig.dateFilter;
      } else {
        this.dateFilter = Object.assign(DateFilterItems[0], {
          displayText: DateFilterItems[0].displayName
        });
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
    next();
    if (to.path !== from.path) {
      this.initManageHistory();
      this.searchHistory();
    }
  },
  mounted() {
    this.initManageHistory();
  }
});
